import { render, staticRenderFns } from "./WorkflowReceptionDetailEditDialog.vue?vue&type=template&id=bb740612&scoped=true&"
import script from "./WorkflowReceptionDetailEditDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowReceptionDetailEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "@/scss/workflow.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./WorkflowReceptionDetailEditDialog.vue?vue&type=style&index=1&id=bb740612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb740612",
  null
  
)

export default component.exports